import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useAuthState } from '../../../../../Helper/Context/context';
import { PlantationDetailsPartThreeTableDataAPI } from '../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice';
import { Loading } from '../../../../../Helper/LogoLoader/LogoLoader';
import DeletePopUP from '../../../../CommonPopUp/DeletePopUp';
import { ThreatWildAnimalsDeleteAPI } from '../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartFourthSlice';

export default function PesticidesTable(props) {

    const { PlantationDetailsPart4, setPlantationDetailsPart4, T_BeneficiaryPlantationDetailsID, M_BeneficiaryDetailsID, IsPesticidesData, setIsPesticidesData, setPesticidesName, FrequencyPesticidesId, setFrequencyPesticidesId } = props


    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails


    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })
    const handleShowDelete = (data) => {
        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }

    const handleIsPesticidesData = () => {
        setIsPesticidesData(!IsPesticidesData)
        handleShowDelete()
        setPesticidesName('')
        setFrequencyPesticidesId({
            ...FrequencyPesticidesId,
            ID: 0,
            Label: "Select...",
        })

    }

    useEffect(() => {
        const data = {
            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantationPart4",
            token: token,
            setPlantationDetailsPart4: setPlantationDetailsPart4,
        }
        // dispatch(PlantationDetailsPartThreeTableDataAPI({ data }))

    }, [IsPesticidesData])
    const { isLoading } = useSelector(state => state.PlantationDetailsPartTwoTableData)

    const handleDeleteData = () => {

        const data = {
            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "Pesticide",
            token: token,
            handleIsAnimalData: handleIsPesticidesData
        }
        dispatch(ThreatWildAnimalsDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.ThreatWildAnimalsDeleteData)


    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}

            {
                PlantationDetailsPart4[0].whichPesticide && PlantationDetailsPart4[0].whichPesticide != '' ?
                    <div className="table-responsive p-0" >
                        <table className="table table-bordered">
                            <thead>
                                <tr className=" text-white">
                                    {/* <th className="text-center">Sr. No.</th> */}
                                    <th className="text-center">Name of Pesticides</th>
                                    <th className="text-center">Frequency for Pesticides</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    PlantationDetailsPart4 && PlantationDetailsPart4.length > 0 ?
                                        PlantationDetailsPart4.map((i, j) => {
                                            return (

                                                <tr>
                                                    {/* <td align="center">{j + 1}</td> */}
                                                    <td align="center"> {i.whichPesticide ? i.whichPesticide : '-'}</td>
                                                    <td align="center"> {i.frequency_For_Pesticide_M_Indicator ? i.frequency_For_Pesticide_M_Indicator : '-'}</td>
                                                    <td align="center">

                                                        <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                            onClick={() => handleShowDelete(i)}
                                                            title="Do you want to delete this record?"></i>
                                                    </td>

                                                </tr>


                                            )
                                        })
                                        :
                                        <span style={{ color: "red" }}>No data found</span>
                                }


                            </tbody>
                        </table>

                    </div>
                    :
                    ''
            }
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }
        </div>

    )
}
